import { string, object } from 'yup';
import { isValid } from 'psl';

import * as constants from '@/constants';
import i18n from '@/settings/i18n';

const EmailValidator = string()
  .max(
    constants.EMAIL_LENGTH,
    i18n.t('ui.error.targeted.maxLength', {
      target: i18n.t('ui.expression.email'),
      length: constants.EMAIL_LENGTH,
    }),
  )
  .test('is-valid-domain', 'Invalid email domain', function (value) {
    if (!value) {
      return true;
    }

    const domain = value.split('@')[1];
    if (domain && !isValid(domain)) {
      throw this.createError({
        message: i18n.t('ui.error.targeted.format', {
          target: i18n.t('ui.expression.email'),
        }),
      });
    }

    return true;
  })
  .matches(
    constants.EMAIL_PATTERN,
    i18n.t('ui.error.targeted.format', {
      target: i18n.t('ui.expression.email'),
    }),
  )
  .trim();

export const emailSchema = object({
  email: EmailValidator.required(i18n.t('ui.error.required.input')),
  cc: EmailValidator.nullable(),
}).required();
